import call from "@/conn-global/api";

export default {
  // getDataApi: ({ commit }) => {
  //   call
  //     .get("https://api.coindesk.com/v1/bpi/currentprice.json")
  //     .then((res) => {
  //       if (res != undefined) {
  //         commit("addDataApi", res.data);
  //       }
  //     })
  //     .catch((err) => {
  //       alert(err);
  //     });
  // },
  postDataLoginAuth: async ({ commit }, data) => {
    let response = await call
      .post("/v1/auth/login", data, false)
      .then((res) => {
        if (res != undefined) {
          commit("addDataLogin", res.data.data);
          // console.log(res.data.data.token);
          // localStorage.removeItem("token");
          return res;
        }
        return res;
      })
      .catch((err) => {
        return err.response;
      });
    return response;
  },
  postDataRegisterAuth: async ({ commit }, data) => {
    let response = await call
      .post("/v1/auth/register", data, false)
      .then((res) => {
        // console.log(res);
        if (res != undefined) {
          commit("addDataRegis", res.data.status);
          // console.log(res.data.data.token);
          return res;
        }
        return res;
      })
      .catch((err) => {
        return err.response;
      });
    return response;
  },

  postRequestOtp: async ({ commit }, data) => {
    let response = await call
      .post("/v1/auth/request_otp", data, false)
      .then((res) => {
        if (res != undefined) {
          commit("requestDataOtp", res.data.data);
          // console.log(res.data.data.token);
          return res.data;
        }
        return res.data;
      })
      .catch((err) => {
        return err.response;
      });
    return response;
  },

  postRequestOtpForgot: async ({ commit }, data) => {
    let response = await call
      .post("/v1/auth/request_otp_forgot_password", data, false)
      .then((res) => {
        if (res != undefined) {
          commit("requestDataOtpForgot", res.data.data);
          return res;
        }
        return res;
      })
      .catch((err) => {
        return err.response;
      });
    return response;
  },

  postForgotPassword: async ({ commit }, data) => {
    let response = await call
      .post("/v1/auth/forgot_password", data, false)
      .then((res) => {
        if (res != undefined) {
          commit("requestPasswordChange", res.data.data);
          return res;
        }
        return res;
      })
      .catch((err) => {
        return err.response;
      });
    return response;
  },
};
